"use client";

import React from "react";
import { Bed, ChefHat, Sofa, Bath, Layers, DoorOpen } from "lucide-react";

/* Room additions only (owner request Sept 17). Deck and patio work stays on the Projects page.
   Photos of completed additions go here as each project finishes; no city names in captions. */
const additionTypes = [{
  Icon: Bed,
  title: "Bedroom additions",
  body: "A new bedroom framed, wired, insulated and finished to match the rest of the house, with closet and egress window per code."
}, {
  Icon: Bath,
  title: "Primary suite additions",
  body: "A primary bedroom with its own bathroom and closet, including the plumbing and electrical work the new rooms need."
}, {
  Icon: ChefHat,
  title: "Kitchen additions and expansions",
  body: "Pushing the kitchen out into new square footage, with the structural work, utilities and finishes handled by one team."
}, {
  Icon: Sofa,
  title: "Family and living room additions",
  body: "Added living space tied into the existing roofline and foundation so it reads as part of the original house."
}, {
  Icon: Layers,
  title: "Second story additions",
  body: "A full second floor, engineered and permitted, including the stair opening and upgrades the existing structure needs."
}, {
  Icon: DoorOpen,
  title: "In-law and guest suites",
  body: "An attached suite with its own entrance, bathroom and space for a kitchenette where the city allows it."
}];
export default function KitchenGallery() {
  return <section id="additions" data-nav="light" className="bg-background text-foreground py-16 md:py-20 lg:py-24 border-b border-border">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="flex flex-col items-center text-center max-w-3xl mx-auto mb-10 lg:mb-14">
          <span className="text-xs font-semibold uppercase tracking-[0.18em] text-primary mb-3">Room additions</span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-serif font-bold tracking-tight text-foreground mb-4">
            Additions we build
          </h2>
          <p className="text-base sm:text-lg text-muted-foreground font-sans leading-relaxed">
            Every addition is engineered, permitted and built by our own licensed team, tied into the existing house so it does not look added on.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {additionTypes.map(t => <div key={t.title} className="rounded-xl border border-border bg-card p-6 shadow-sm">
              <t.Icon className="size-6 text-primary" />
              <h3 className="mt-4 text-lg font-semibold">{t.title}</h3>
              <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{t.body}</p>
            </div>)}
        </div>
      </div>
    </section>;
}